<script setup lang="ts">
import { useI18n } from '@thehotelsnetwork/widgets-core';

const props = defineProps<{
  perks: number;
}>();
const { t, tc } = useI18n();
</script>

<template>
  <div class="text-s leading-4 trigger-content">
    <p class="font-bold">
      {{ t('Compare Prices') }}
    </p>
    <p v-if="props.perks">
      {{ tc(
        'You are getting {num} perk | You are getting {num} perks',
        props.perks,
        { num: props.perks },
      ) }}
    </p>
  </div>
</template>

<style scoped>
.trigger-content {
  text-align: initial;
}
</style>
